import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { Nav, Navbar, NavItem, NavbarBrand, Collapse } from 'reactstrap';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { logOut } from '../../../../redux/modules/auth';
import logo from '../../../../assets/images/logo.png';
import Icon from '@mdi/react';
import {
    mdiHomeOutline,
    mdiProgressClock,
    mdiAccountOutline,
    mdiAccountSchoolOutline,
    mdiCalendarCheckOutline,
    mdiCalendarMonthOutline,
    mdiAccountGroupOutline,
    mdiHumanMaleBoard,
    mdiAbjadArabic,
    mdiCogOutline,
    mdiRoutesClock,
    mdiCashSync,
    mdiAccountCreditCardOutline,
    mdiBadgeAccountOutline
} from '@mdi/js';

import './TopBar.css';

const TopBar = () => {
    const { user } = useSelector(state => state.auth);
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const doLogOut = () => {
        dispatch(logOut());
    };

    return (
        <Navbar className="TopBar fixed-top flex-md-nowrap p-0 shadow" expand="md">
            <NavbarBrand href="/" className="navbar-brand">
                <img src={logo} className="logo" alt="logo" />
            </NavbarBrand>
            <Collapse navbar>
                <Nav className="flex-row">
                    <NavItem>
                        <NavLink to="/" className="nav-link">
                            <Icon path={mdiHomeOutline} size={1} />
                            <span>&nbsp;{t("app.home")}</span>
                        </NavLink>
                    </NavItem>
                    {user?.isSuperAdmin() && (
                    <NavItem>
                        <NavLink to="/members/list" className="nav-link">
                            <Icon path={mdiBadgeAccountOutline} size={1} />
                            <span>&nbsp;{t("app.members")}</span>
                        </NavLink>
                    </NavItem>
                    )}
                    {user?.isAdmin() && (
                    <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle nav caret>
                            <Icon path={mdiProgressClock} size={1} />
                            <span>&nbsp;{t('app.scholar_life')}</span>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem>
                                <NavLink to="/planning" className="nav-link">
                                    <Icon path={mdiCalendarMonthOutline} size={1} />
                                    <span>&nbsp;{t("app.planning")}</span>
                                </NavLink>
                            </DropdownItem>
                            <DropdownItem>
                                <NavLink to="/courses/list" className="nav-link">
                                    <Icon path={mdiCalendarCheckOutline} size={1} />
                                    <span>&nbsp;{t("app.appeals")}</span>
                                </NavLink>
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    )}
                    {user?.isAdmin() && (
                    <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle nav caret>
                            <Icon path={mdiAccountSchoolOutline} size={1} />
                            <span>&nbsp;{t('app.management')}</span>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem>
                                <NavLink to="/students/list" className="nav-link">
                                    <Icon path={mdiAccountSchoolOutline} size={1} />
                                    <span>&nbsp;{t("app.students")}</span>
                                </NavLink>
                            </DropdownItem>
                            <DropdownItem>
                                <NavLink to="/groups/list" className="nav-link">
                                    <Icon path={mdiAccountGroupOutline} size={1} />
                                    <span>&nbsp;{t("app.groups")}</span>
                                </NavLink>
                            </DropdownItem>
                            <DropdownItem>
                                <NavLink to="/teachers/list" className="nav-link">
                                    <Icon path={mdiHumanMaleBoard} size={1} />
                                    <span>&nbsp;{t("app.teachers")}</span>
                                </NavLink>
                            </DropdownItem>
                            <DropdownItem>
                                <NavLink to="/subjects/list" className="nav-link">
                                    <Icon path={mdiAbjadArabic} size={1} />
                                    <span>&nbsp;{t("app.subjects")}</span>
                                </NavLink>
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    )}
                    {user?.isAdmin() && (
                    <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle nav caret>
                            <Icon path={mdiCashSync} size={1} />
                            <span>&nbsp;{t('app.accounting')}</span>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem>
                                <NavLink to="/invoices/list" className="nav-link">
                                    <Icon path={mdiAccountCreditCardOutline} size={1} />
                                    <span>&nbsp;{t("app.enrolment_fees")}</span>
                                </NavLink>
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    )}
                    {user?.isAdmin() && (
                    <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle nav caret>
                            <Icon path={mdiCogOutline} size={1} />
                            <span>&nbsp;{t('app.settings')}</span>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem>
                                <NavLink to="/users/list" className="nav-link">
                                    <Icon path={mdiAccountOutline} size={1} />
                                    <span>&nbsp;{t("app.users")}</span>
                                </NavLink>
                            </DropdownItem>
                            <DropdownItem>
                                <NavLink to="/holidays/list" className="nav-link">
                                    <Icon path={mdiRoutesClock} size={1} />
                                    <span>&nbsp;{t("app.holidays")}</span>
                                </NavLink>
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    )}
                </Nav>
                {!!user && (
                <Nav className="ml-auto" navbar>
                    <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle nav caret>
                            <i className="fa fa-user"></i>&nbsp;{user.firstname}
                        </DropdownToggle>
                        <DropdownMenu end>
                            <DropdownItem>
                                <NavLink to={`/users/show/${user.id}`} className="text-dark">
                                    <Icon path={mdiAccountOutline} size={1} />&nbsp;
                                    {t('app.my_profil')}
                                </NavLink>
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem onClick={doLogOut}>
                                <i className="fa fa-sign-out"></i>&nbsp; {t('app.logout')}
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Nav>
                )}
                {!user && (
                <Nav className="ml-auto" navbar>
                    <NavItem>
                        <NavLink to="/login" className="nav-link">
                            <Icon path={mdiAccountOutline} size={1} />
                            <span>&nbsp;{t("app.login")}</span>
                        </NavLink>
                    </NavItem>
                </Nav>
                )}
            </Collapse>
        </Navbar>
    );
};

export default TopBar;
